app.training = () => {
  const monthFilters = document.querySelectorAll('.month-selector i');
  const filterForm = document.querySelector('#filter-form');
  const monthInput = document.querySelector('#month');
  const state = document.querySelector('#state');
  const city = document.querySelector('#city');

  function init() {
    for (filter of monthFilters) {
      filter.addEventListener('click', filterMonths);
    }
    state.addEventListener('change', filterSubmit);
    city.addEventListener('change', filterSubmit);
  }

  let filterMonths = event => {
    event.preventDefault();
    const month = event.currentTarget.getAttribute('data-month');
    monthInput.value = month;
    filterForm.submit();
  };

  let filterSubmit = event => {
    event.preventDefault();
    filterForm.submit();
  };

  return init();
};
